import React from "react";
import Modal from "./Modal";
import { connect } from "react-redux";
import { FaFlag } from "react-icons/fa";
import * as actions from "../redux/actions/adReportActions";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import MiniLoader from "./MiniLoader";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/ModalReportAd.css";

function ReportOption({ item, selected, onSelect }) {
  return (
    <label className={`report-ad-option${selected ? " is-selected" : ""}`}>
      <input
        type="radio"
        name="reason_id"
        value={item.key}
        checked={selected}
        onChange={() => onSelect(item.key)}
      />
      <span className="report-ad-option__marker" aria-hidden="true" />
      <span className="report-ad-option__label">{item.label}</span>
    </label>
  );
}

class ModalReportAd extends React.Component {
  state = {
    description: "",
    reasonId: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.setState({ description: "", reasonId: "" });
      if (!this.props.adReportOptionsList.length) {
        this.fetchAdReportOptions();
      }
    }
  }

  fetchAdReportOptions = async () => {
    try {
      await this.props.LoadReportOption(this.props.user_id, this.props.token);
      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
      }
    } catch (error) {
      console.log(error);
    }
  };

  onChangeDescription = (event) => {
    this.setState({ description: event.target.value });
  };

  onSelectReason = (reasonId) => {
    this.setState({ reasonId: String(reasonId) });
  };

  storeReport = async () => {
    if (!this.state.reasonId) {
      alertify.warning(I18n.t("ad_report_reason_required"));
      return;
    }

    try {
      await this.props.AddReportAd(
        this.state.description,
        this.state.reasonId,
        this.props.ad.Id,
        this.props.user_id,
        this.props.token
      );

      if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
        return;
      }

      alertify.success(I18n.t("saved_succesfull"));
      this.props.onClose();
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { isOpen, onClose, adReportOptionsList, loading } = this.props;
    const { description, reasonId } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={<Translate value="ad_report_title" />}
      >
        <div className="report-ad-modal">
          <div className="report-ad-modal-hero">
            <span className="report-ad-modal-icon" aria-hidden="true">
              <FaFlag />
            </span>
            <p className="report-ad-modal-title">
              <Translate value="ad_report_kind" />
            </p>
            <p className="report-ad-modal-hint">
              <Translate value="ad_report_hint" />
            </p>
          </div>

          {loading ? (
            <div className="report-ad-modal-loading">
              <MiniLoader />
            </div>
          ) : (
            <div className="report-ad-options" role="radiogroup" aria-label={I18n.t("ad_report_kind")}>
              {adReportOptionsList.map((item) => (
                <ReportOption
                  key={item.key}
                  item={item}
                  selected={String(reasonId) === String(item.key)}
                  onSelect={this.onSelectReason}
                />
              ))}
            </div>
          )}

          <div className="report-ad-field">
            <label className="report-ad-label" htmlFor="report_ad_comment">
              <Translate value="comments" />
            </label>
            <textarea
              id="report_ad_comment"
              className="report-ad-textarea"
              name="comment"
              rows={4}
              value={description}
              placeholder={I18n.t("ad_report_comment_placeholder")}
              onChange={this.onChangeDescription}
            />
          </div>

          <div className="report-ad-footer">
            <button
              type="button"
              className="report-ad-btn report-ad-btn--secondary"
              onClick={onClose}
            >
              <Translate value="close" />
            </button>
            <button
              type="button"
              className="report-ad-btn report-ad-btn--danger"
              disabled={loading || !adReportOptionsList.length}
              onClick={this.storeReport}
            >
              <Translate value="ad_report_button" />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,
    adReportOptionsList: reducer.adReport.list,
    loading: reducer.adReport.loading,
    error: reducer.adReport.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  AddReportAd: (message, reason_id, id, user_id, token) =>
    dispatch(actions.newItem({ message, reason_id, id, user_id, token })),
  LoadReportOption: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalReportAd);
